import { endpoints } from '../endpoints'
import { http } from '../http'
import {
  ShoppingCart,
  FlowerProduct,
  GenerateTokenResponse,
  ShippingData,
  DeliveryDatesResponse,
  ExternalDeliveryDatesResponse,
  MemorialTree,
} from '../../types'

enum Actions {
  ADD = 'add',
  REMOVE = 'remove',
}

interface SubmitPaymentParams {
  shipping_data: Omit<ShippingData, 'shippingFormVariant'>
  billing_data: {
    first_name: string
    last_name: string
    address_line_1: string
    address_line_2: string
    city: string
    state: string
    zip: string
    email: string
    phone: string
  }
  flower_token: string
  tree_token: string
  case_id: number
}

interface OrderTotalParam {
  price: number
  code: string
  zip: string
}
interface OrderTotalParams {
  facility_id: number | null
  products: OrderTotalParam[]
}
export interface OrderTotalResponse {
  TAXTOTAL?: number
  SUBTOTAL?: number
  ORDERTOTAL?: number
  FLORISTONETAX?: number
  FLORISTONEDELIVERYCHARGE?: number
  errors?: string[]
}

export const flowerstore = {
  loadProducts: (facilityID: number | null): Promise<FlowerProduct[]> =>
    http.get(endpoints.flowerstoreProducts(facilityID)),
  loadMemorialTrees: (): Promise<MemorialTree[]> => http.get(endpoints.memorialTrees),
  calculateOrderTotal: (cartID: string, params: OrderTotalParams): Promise<ShoppingCart> =>
    http.post(endpoints.flowerstoreCalculateOrderTotal(cartID), params),
  generateToken: (): Promise<GenerateTokenResponse> => http.get(endpoints.flowerstoreGenerateToken),
  getDeliveryDates: async (zip: string): Promise<DeliveryDatesResponse> => {
    const response = await http.get<ExternalDeliveryDatesResponse>(
      `${endpoints.flowerstoreDeliveryDates}?zip=${zip}`,
    )

    if (response.errors) {
      throw new Error(response.errors[0])
    }

    return { delivery_dates: response.DATES || [] }
  },
  submitPayment: (cartID: string, params: SubmitPaymentParams): Promise<ShoppingCart> =>
    http.post(endpoints.flowerstoreSubmitPayment(cartID), params),
}
